import React from 'react'
import { withRouter } from 'react-router-dom'

import Alert from 'components/Alert'
import Button from 'components/Button'
import FieldWithInput from 'components/FieldWithInput'
import FormFooter from 'components/FormFooter'
import Input from 'components/Input'
import paths from 'constants/paths'
import { auth } from 'data'
import assertions from 'utils/assertions'

export class PasswordResetForm extends React.Component {
  state = {
    email: '',
    emailValid: false,
    error: null,
    submitting: false,
  }

  clearError = () => {
    this.setState({ error: null })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.clearError()

    auth.triggerPasswordReset(this.state.email)
      .then(() => {
        console.log('sending password reset email')

        // TODO: success state
        this.props.history.push(paths.REPORTS)
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error })
      })
  }

  render() {
    const { emailValid, error, submitting } = this.state

    return (
      <form className="PasswordResetForm" onSubmit={this.handleSubmit}>
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'email',
            autoComplete: 'username email',
            name: 'email',
            icon: 'user',
            onFocus: this.clearError,
          }}
          label="Email"
          labelAsPlaceholder
          validate={(e) => assertions.email(e.target.value)}
          onInvalidChange={() => this.setState({ emailValid: false })}
          onValidChange={(e) =>
            this.setState({
              email: e.target.value,
              emailValid: true,
            })
          }
        />
        <FormFooter>
          <Button
            type="submit"
            disabled={!emailValid || submitting}
            full
            onClick={this.handleSubmit}>
            Reset password
          </Button>
        </FormFooter>
        {error &&
          <Alert>
            {error.message}
          </Alert>
        }
      </form>
    )
  }
}

export default withRouter(PasswordResetForm)



// WEBPACK FOOTER //
// ./src/components/PasswordResetForm/PasswordResetForm.js